export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/noop.js
// module id = 113
// module chunks = 0